import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { NavbarComponent } from '../../components/Navbar/Navbar.component';
// import Header from "../../components/Header";
import { Container } from 'reactstrap';
import Footer from '../../components/Footer';
import { SidebarComponent } from '../../components/Sidebar/Sidebar.component';
import FreshdeskWebChat from '../../components/FreshdeskWebChat';
import { SetupGuideProvider } from '../../contexts/SetupGuide.context';
import { NavbarSlotProvider } from '../../contexts/NavbarSlot.context';
import { SetupGuide } from '../../views/DashboardOverview/components/SetupGuide.component';
import AppLogo from '@/assets/img/brand/logo-transparent-blue.png';

const Main = ({ location, children }) => {
  // const hasNavbar = location && location.pathname.includes('dashboard') ? true : false
  const hasNavbar = true;
  const [bannerVisible, setBannerVisible] = useState(false);

  // Check if banner should be visible
  useEffect(() => {
    const checkBannerVisibility = () => {
      const bannerElement = document.querySelector(
        '.subscription-warning-banner'
      );
      const isVisible =
        bannerElement &&
        bannerElement.style.display !== 'none' &&
        bannerElement.offsetParent !== null;

      console.log('Subscription: Main Layout - Banner visibility:', {
        bannerElement: !!bannerElement,
        display: bannerElement?.style.display,
        offsetParent: !!bannerElement?.offsetParent,
        isVisible,
        paddingTop: isVisible ? '60px' : '0px',
      });

      setBannerVisible(isVisible);
    };

    // Check immediately
    checkBannerVisibility();

    // Set up observer to watch for banner changes
    const observer = new MutationObserver(checkBannerVisibility);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    return () => observer.disconnect();
  }, []);
  return (
    <SetupGuideProvider>
      <NavbarSlotProvider>
        <FreshdeskWebChat />
        <SidebarComponent
          location={location}
          logo={{
            innerLink: '/dashboard-overview',
            imgSrc: AppLogo,
            imgAlt: '...',
          }}
        />
        <div
          className="main-content"
          id="main_portal_target"
          style={{
            paddingTop: bannerVisible ? '60px' : '0px',
            transition: 'padding-top 0.3s ease, margin-left 0.3s ease',
            backgroundColor: '#f9fafb',
          }}
        >
          <div className="main-content-child">
            {hasNavbar && <NavbarComponent location={location} />}

            <div className="content">{children} </div>
            <Container fluid>
              <Footer />
            </Container>
          </div>
        </div>
        <SetupGuide />
      </NavbarSlotProvider>
    </SetupGuideProvider>
  );
};

Main.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(Main);
